import { HeaderPanel } from '../../../HeaderPanel';
import React from 'react';
import { headerPanelOptions, getDetailsItemClasses } from '../panelSettings';
import { EntityHeaderDto } from '@decisions/server/DecisionsFramework/ServiceLayer/Services/EntityDetails';
import { DependenciesList } from './DependenciesList';
import './Dependencies.less';

export const detailsDependenciesClass = 'dp-entitydetails-dependency';
interface DependenciesPanelProps {
  dependencyTo?: EntityHeaderDto[];
  dependencyFrom?: EntityHeaderDto[];
  registrationClick: (id: string, typeName: string, clickEvent: MouseEvent) => void;
}

export function DependenciesPanel({ dependencyTo, dependencyFrom, registrationClick }: DependenciesPanelProps) {
  return (
    <HeaderPanel {...headerPanelOptions('primary', 'Dependencies')}>
      <div className={`${detailsDependenciesClass}`}>
        <ul className={`${detailsDependenciesClass}__from`}>
          {<li className={getDetailsItemClasses(detailsDependenciesClass, true)}>Depends On</li>}
          {dependencyFrom && (
            <DependenciesList dependencies={dependencyFrom} registrationClick={registrationClick} />
          )}
        </ul>
        <ul className={`${detailsDependenciesClass}__to`}>
          {<li className={getDetailsItemClasses(detailsDependenciesClass, true)}>Depends On Me</li>}
          {dependencyTo && (
            <DependenciesList dependencies={dependencyTo} registrationClick={registrationClick} />
          )}
        </ul>
      </div>
    </HeaderPanel>
  );
}